// Copyright (c) Microsoft. All rights reserved.

export interface ChatMemorySource {
    id: string;
    chatId: string;
    sourceType: string;
    name: string;
    hyperlink?: string;
    sharedBy: string;
    createdOn: number;
    tokens: number;
    documentUploadState: DocumentUploadState;
    status?: string;
    viewQuestionsUri?: string;
}

export enum DocumentUploadState {
    InProgress,
    Complete,
}
